// extracted by mini-css-extract-plugin
export default {"AssignDiscipline":"AssignStaffToTherapist_AssignDiscipline__nfZqW","modalBody":"AssignStaffToTherapist_modalBody__lvjLK","list":"AssignStaffToTherapist_list__ecHG+"};